import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import {
  detailSmall,
  heading100,
  heading200,
  heading300,
} from "../stitches/combinedStyles";
import { styled } from "../stitches/stitches.config";

const PrivacyPolicy = () => {
  const data = useStaticQuery(graphql`
    query {
      markdownRemark(fileAbsolutePath: { regex: "/privacyPolicyContent/" }) {
        html
      }
    }
  `);
  return (
    <Container>
      <Content
        dangerouslySetInnerHTML={{ __html: data.markdownRemark.html }}
      ></Content>
    </Container>
  );
};

export default PrivacyPolicy;

const Container = styled("div", {
  width: "90%",
  maxWidth: 750,
  margin: "auto",
  paddingBottom: 100,
});
const Content = styled("div", {
  "& p, ol, li": {
    ...detailSmall,
    color: "$bayoux",
  },
  "& h2": {
    ...heading200,
  },
  "& h3": {
    ...heading100,
  },
  "& h4": {},
});
